import { Accordion as BaseAccordion } from "@base-ui/react/accordion";
import clsx from "clsx";
import type React from "react";
import { forwardRef, type ReactNode } from "react";
import { IconChevronDown } from "../icons";
import {
  accordionHeaderClass,
  accordionItemClass,
  accordionPanelClass,
  accordionRootClass,
  accordionTriggerClass,
} from "./styles.css";

interface AccordionProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "defaultValue"> {
  header: ReactNode;
}

export const Accordion = forwardRef(function Accordion(
  { header, children, className, ...props }: AccordionProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <BaseAccordion.Root
      className={clsx(accordionRootClass, className)}
      data-slot="accordion"
      {...props}
    >
      <BaseAccordion.Item
        className={accordionItemClass}
        ref={ref}
        value="item"
        data-slot="accordion-item"
      >
        <BaseAccordion.Header
          className={accordionHeaderClass}
          data-slot="accordion-header"
        >
          <BaseAccordion.Trigger
            className={accordionTriggerClass}
            data-slot="accordion-trigger"
          >
            <IconChevronDown data-slot="accordion-icon" />
            {header}
          </BaseAccordion.Trigger>
        </BaseAccordion.Header>
        <BaseAccordion.Panel
          className={accordionPanelClass}
          keepMounted
          data-slot="accordion-panel"
        >
          <div
            style={{ overflow: "hidden", minHeight: 0 }}
            data-slot="accordion-content"
          >
            {children}
          </div>
        </BaseAccordion.Panel>
      </BaseAccordion.Item>
    </BaseAccordion.Root>
  );
});

Accordion.displayName = "Accordion";
